import { createAction } from 'typesafe-actions'
import { IAccount, IAddUBO, IUserAccount } from '../types'

export const selectAccountType = createAction('SELECT_ACCOUNT_TYPE', (accountType: string) => accountType)<string>()
export const createAccount = createAction('CREATE_ACCOUNT', (account: IAccount) => account)<IAccount>()
export const addUBO = createAction('ADD_UBO', (ubo: IAddUBO) => ubo)<IAddUBO>()
export const createUserAccount = createAction(
  'CREATE_USER_ACCOUNT',
  (userAccount: IUserAccount) => userAccount,
)<IUserAccount>()
